"use strict";

angular
	.module('rmContact')
	.config(['gravatarServiceProvider', function ( gravatarServiceProvider ) {

 		gravatarServiceProvider.defaults = {
	        size: 100,
	        "default": 'blank'  //mm = Mystery man as default for missing avatars
	    };

	    // Use https endpoint
	    gravatarServiceProvider.secure = true;
	}]);